import { render, staticRenderFns } from "./Redaction.vue?vue&type=template&id=3074fcb9&"
import script from "./Redaction.vue?vue&type=script&lang=ts&"
export * from "./Redaction.vue?vue&type=script&lang=ts&"
function injectStyles (context) {
  
  var style0 = require("./Redaction.vue?vue&type=style&index=0&id=3074fcb9&prod&lang=scss&")
if (style0.__inject__) style0.__inject__(context)

}

/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  ,true
)

export default component.exports